import { ConsultationTreatmentTypes } from '@enums/consultation-treatment-types';
import { TreatmentType } from '@models/treatment-types/treatment-type.model';

/**
 * Defines the nurse treatment type.
 */
export const NurseTreatment = new TreatmentType({
  id: '14',
  name: ConsultationTreatmentTypes.Nurse,
  requiresConsultationUpdate: false,
});
